const ErrorCode = Object.freeze({
  UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
  BAD_REQUEST: 'BAD_REQUEST',
  RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
  BACKEND_TIMEOUT: 'BACKEND_TIMEOUT',
  ABORT: 'ABORT',
  FEATURE_NO_QUOTA: 'FEATURE_NO_QUOTA',
  KEYWORD_LIMIT_REACHED: 'KEYWORD_LIMIT_REACHED',
  APP_COUNTRY_KEYWORD_LIMIT_REACHED: 'APP_COUNTRY_KEYWORD_LIMIT_REACHED',
  INVALID_DATE_RANGE: 'INVALID_DATE_RANGE',
  UNAUTHORIZED: 'UNAUTHORIZED',
  TEAM_MEMBER_UNAUTHORIZED_DOMAIN: 'TEAM_MEMBER_UNAUTHORIZED_DOMAIN',
  USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS',
  INVITED_DOMAIN_NOT_ALLOWED: 'INVITED_DOMAIN_NOT_ALLOWED',
  UNSUPPORTED_DOMAIN: 'UNSUPPORTED_DOMAIN',
})

export {
  ErrorCode,
}
